export default __webpack_public_path__ + "static/media/map-pin.b8f04332.svg";